export const MAX_UPLOAD_SIZE =
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  {
    max: 1024 * 1024 * 1000,
  }["__TIER_SIZE__"] || 1024 * 1024 * 500;

export const FRONTEND_UPLOAD_FACTOR = 0.1;
export const BACKEND_UPLOAD_FACTOR = 0.9;
export const ACCEPTED_EXTENSIONS = {
  "application/*": [".docx", ".pdf", ".xlsx", ".txt", ".rtf", ".ods", ".odp", ".odt", ".xls", ".ppt", ".pptx"],
};
export const BATCHED_UPLOAD_SIZE = 10;
